import { render, staticRenderFns } from "./GibAirForm.vue?vue&type=template&id=6aba8b06"
import script from "./GibAirForm.vue?vue&type=script&lang=js"
export * from "./GibAirForm.vue?vue&type=script&lang=js"
import style0 from "./GibAirForm.vue?vue&type=style&index=0&id=6aba8b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports